import SectionHeader from '../../components/ui/section-header'
import { useProposalsSocket } from '../../hooks/socket/use-proposals-socket';
import SearchFilterBar from '../../components/ui/search-filter-bar';
import Pagination from '../../components/ui/pagination';
import ProposalTHead from '../../components/ui/proposal-thead';
import ProposalListTBody from '../../components/module/proposal-status/proposal-list-tbody';
import LoadingViewFile from '../../components/ui/loading-view-file';
import LoadingFile from '../../components/ui/loading-file';
import { proposalHeaderData } from '../../constant/gms-constant';
import { useBookedProposal } from '../../hooks/proposal/user-booked-proposal';
import { useFilesActions } from '../../hooks/actions/use-files-actions';

export default function COCGenerationPage() {

    const { handleViewProposal } = useFilesActions();
    const {
        normalizedOptions,
        errorMessage,
        searchType,
        setSearchType,
        searchValue,
        setSearchValue,
        setPage,
        pagedData,
        loading,
        isErrorBookedProposals,
        handleReload,
        bookedProposals,
        defaultTotalPages,
        proposalDefaultPageSize,
        handleChangePageSize,
    } = useBookedProposal();
    useProposalsSocket()

    const { isLoadingViewCOC, isLoadingGenerateCOC, handleViewCOC } = useFilesActions()

    const tHeads:string[] = [
        proposalHeaderData.cocAction.label,
        proposalHeaderData.proposalStatus.label,
        proposalHeaderData.proposalAs.label,
        proposalHeaderData.groupName.label,
        proposalHeaderData.proposalType.label,
        proposalHeaderData.product.label,
        proposalHeaderData.preparedBy.label,
        // proposalHeaderData.cocAction.label,
    ]

    return (
        <div className="flex h-full min-h-0 w-full flex-col bg-[#f8fafc] rounded-xl border border-gray-200">
            <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
                <SectionHeader
                    title='Certificate of Coverage'
                    subtitle='Generate and view Certificates of Coverage for booked proposals.'
                    icon={
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 3 20 6v5c0 5-3.4 8.7-8 10-4.6-1.3-8-5-8-10V6l8-3Z" />
                            <path strokeLinecap="round" strokeLinejoin="round" d="m9 12 2 2 4-4" />
                        </svg>
                    }
                />
                <div className="mx-auto flex min-h-0 w-full flex-1 flex-col gap-2">
                    <div className="flex min-h-0 flex-1 flex-col overflow-hidden bg-white shadow-sm">
                        <div className="shrink-0 border-b border-gray-200 p-3">
                            <SearchFilterBar
                                searchType={searchType}
                                setSearchType={setSearchType}
                                searchValue={searchValue}
                                setSearchValue={setSearchValue}
                                options={normalizedOptions}
                            />
                        </div>
                        {bookedProposals?.pagination && (
                            <div className="shrink-0 border-b border-gray-200 bg-gray-50/60 p-3">
                                <Pagination
                                    setPage={setPage}
                                    handleReload={handleReload}
                                    pagination={bookedProposals.pagination}
                                    defaultTotalPages={defaultTotalPages}
                                    setDefaultTotalPages={handleChangePageSize}
                                    totalPagesOptions={proposalDefaultPageSize}
                                />
                            </div>
                        )}
                        <div className="min-h-0 flex-1 overflow-auto">
                            <table className="min-w-max w-full border-collapse">
                                <ProposalTHead headers={tHeads}/>
                                <ProposalListTBody
                                    headers={tHeads}
                                    typeOfIcon="update"
                                    isLoadingGetProposal={loading}
                                    isErrorGetProposal={isErrorBookedProposals}
                                    errorMessage={errorMessage}
                                    getProposal={pagedData}
                                    handleEdit={handleViewProposal}
                                    handleGenerate={handleViewCOC}
                                    disableRowClick={true}
                                />
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            {isLoadingViewCOC && ( <LoadingViewFile />)}
            {isLoadingGenerateCOC && ( <LoadingFile />)}
        </div>
    )
}
